import { useCan } from '@refinedev/core';

/** Get permission for accessing certain resource functionality */
export function useCanPerform(resourceName: string): {
  create: boolean,
  show: boolean,
  list: boolean,
  edit: boolean,
  delete: boolean,
} {
  const { data: canCreate } = useCan({ action: 'create', resource: resourceName });
  const { data: canShow } = useCan({ action: 'show', resource: resourceName });
  const { data: canList } = useCan({ action: 'list', resource: resourceName });
  const { data: canEdit } = useCan({ action: 'edit', resource: resourceName });
  const { data: canDelete } = useCan({ action: 'delete', resource: resourceName });

  return {
    create: canCreate?.can || true,
    show: canShow?.can || true,
    list: canList?.can || true,
    edit: canEdit?.can || true,
    delete: canDelete?.can || true,
  };
}

export default useCanPerform;
